// extracted by mini-css-extract-plugin
module.exports = {"slider":"input_slider__1SdiG","sliderWrapper":"input_sliderWrapper__1aCav","sliderValue":"input_sliderValue__gQx9-","disabled":"input_disabled__3SVOw"};